/**
 * Returns the localized text for a stepSaleConfig field.
 * When the app language is not Polish and an English translation exists, uses it.
 * Falls back to the Polish (default) value.
 */
export const getLocalizedStepText = (plText: string, enText: string | undefined, language: string): string => {
  if (language !== "PL" && enText) {
    return enText;
  }
  return plText;
};
